import { createContext } from "react";
export const LayoutGridContainerDefaultPropsContext = createContext({
    spacing: 2,
    rowSpacing: 2,
    columnSpacing: 2,
});
LayoutGridContainerDefaultPropsContext.displayName =
    "LayoutGridContainerDefaultPropsContext";
//# sourceMappingURL=LayoutGridContainerDefaultPropsContext.js.map